import styled from 'styled-components'
import { Heading } from '@notino/react-styleguide'

// components
import DefaultContainer from '../../components/DefaultContainer/DefaultContainer'
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'

export const Container = styled(DefaultContainer)``

export const SalonsListPageWrapper = styled.div`
	display: flex;
	gap: 32px;
`

export const SalonsPageBreadcrumbs = styled(Breadcrumb)`
	margin-bottom: 24px;
`

export const Grid = styled.div`
	flex: 1;
	min-width: 0; // important so the Grid does not stretch when children overflow
`

export const MainTitle = styled(Heading.H1)`
	font-weight: 500;
	margin-top: 0;
	margin-bottom: 20px;
	text-align: left !important; // override for notino global styles
`
